var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBallon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31,
    height: 43,
    viewBox: "0 0 31 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0186 35.1762L14.7227 35.8636L14.7204 35.8709L14.7245 35.8755C15.014 36.201 17.3904 43.2806 26.7824 39.2293L26.8921 38.5014C17.616 42.507 15.3157 35.5103 15.0228 35.181L15.0186 35.1762Z",
    fill: "#1F50B1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5749 33.5128C10.113 32.9179 1.08917 28.4761 0.689596 15.4679C0.190123 -0.792354 13.4761 0.0999774 15.8736 0.199125C18.271 0.298273 30.7579 1.68634 30.0586 15.7654C29.3938 29.1503 22.0477 32.857 15.5739 33.4455C15.8736 34.0298 16.4729 35.2975 16.4729 35.6941C16.4729 36.1898 13.6759 35.7932 13.2763 35.6941C12.8767 35.5949 14.2753 33.4682 14.5749 33.5128Z",
    fill: "#1F50B1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M29.499 10.014C27.0756 1.28116 17.8935 0.28266 15.8736 0.199125C15.8286 0.197267 15.7799 0.195131 15.7275 0.192835C12.983 0.0725594 0.199482 -0.48768 0.689596 15.4679C0.868138 21.2803 2.76854 25.3824 5.21446 28.1952C15.335 24.4983 23.8284 18.0906 29.499 10.014Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6554 7.78815C8.67033 8.92776 6.69755 9.50413 5.75678 8.45211C4.81943 7.42478 5.26948 5.16295 7.25476 4.02353C9.22851 2.86665 11.895 3.34869 12.8244 4.38314C13.7732 5.42784 12.6293 6.63152 10.6554 7.78815Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.12274 12.8495C4.59959 13.8146 3.68 13.9777 2.90227 13.1169C2.1278 12.2595 1.78908 10.7032 2.3122 9.73822C2.83121 8.77057 4.00426 8.76878 4.77778 9.62707C5.55651 10.4873 5.64165 11.8819 5.12274 12.8495Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBallon);
export default __webpack_public_path__ + "static/media/ballon.97e253401acf2004caa2.svg";
export { ForwardRef as ReactComponent };